import { Skeleton } from '@/shared/ui/atoms';

/**
 * Skeleton do formulário de Banner enquanto os dados da tela carregam.
 *
 * Reproduz o esqueleto real da tela — barra de idioma, três cards de campos à
 * esquerda e o painel de preview à direita —, para o layout não pular quando o
 * conteúdo chega.
 */
export function BannerFormSkeleton() {
  return (
    <div className="flex flex-col items-start gap-xxs lg:flex-row" aria-busy="true">
      <div className="flex w-full min-w-none flex-1 flex-col gap-xxs">
        <Skeleton className="h-[4.5rem] w-full rounded-md" />
        <Skeleton className="h-[16rem] w-full rounded-md" />
        <Skeleton className="h-[10rem] w-full rounded-md" />
        <Skeleton className="h-[12rem] w-full rounded-md" />
      </div>
      <Skeleton className="h-[34rem] w-full rounded-md lg:max-w-[420px]" />
    </div>
  );
}
